/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IReports = DealerwareWebComponents.IReportsConfiguration
    import Languages = DealerwareWebComponents.Languages


    getDealerwareWebComponentsModule()
        .constant(
            'apiToGridMapTransactions', {
                'reservation_confirmation'      : 'reservation_confirmation_token',
                'transaction_processor_code'    : 'transaction_code',
                'transaction_processor_text'    : 'transaction_text'
            }
        );

    export class ReportsTransactionsDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$filter',
            'apiToGridMapTransactions',
            'DealerwareContractCollection',
            '$dealerwareNotification',
            '$state',
            '$controller',
            'uiGridConstants',
            'braintreeTransactionCodes',
            'braintreeTransactionStatuses',
            'braintreeTransactionTypes',
            '$dealerwareInternationalizationData'
        ];

        private reports             : any = { };
        private gridColumns         : any;

        private defaultGridSorts    : any = {
            sort_by         : 'transaction_date',
            sort_direction  : 'desc'
        };

        private configuration        : IReports;

        private menuizedBraintreeApiResponses : any = {
            codes: null, statuses: null, types: null
        };

        public labels               : {};

        constructor(
            private $scope                           : ng.IScope,
            private $filter                          : any,
            private apiToGridMapTransactions         : any,
            private DealerwareContractCollection     : any,
            private $dealerwareNotification          : any,
            private $state                           : any,
            private $controller                      : any,
            private uiGridConstants                  : any,
            private braintreeTransactionCodes        : any[],
            private braintreeTransactionStatuses     : any[],
            private braintreeTransactionTypes        : any[],
            public $dealerwareInternationalizationData   : any
        ) {
            this.getLabels('contracts');
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.report.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.report.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public initColumns(): void {
            var that = this;

            var filterHeaderHtml = '<div class="report-filter-button-container">'
                + '<md-button class="md-icon-button" style="margin: 0;" aria-label="Refresh" '
                + 'ng-click="col.colDef.showModal(this)">'
                + '<md-icon md-svg-icon="filter" class="icon-filter"></md-icon>'
                + '</md-button>'
                + '</div>';

            var numericTemplate = 'dealerware-transactions-numeric-filter';

            this.gridColumns = [

                {
                    name            : 'Transaction ID',
                    displayName     : that.labels.report.columnHeaders.transaction_id,
                    field           : 'transaction_id',
                    visible         : true
                },

                {
                    name            : 'Contract ID',
                    displayName     : that.labels.report.columnHeaders.contract_id,
                    field           : 'reservation_confirmation_token',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.reservation_confirmation_token) ? '' :
                            '<a class="reports-transactions-table-cell-contract-id" href="' + that.$state.href('root.private.application.contracts.details',
                            { contractId: this.reservation_id }
                            ) + '">' + this.reservation_confirmation_token + '</a>';
                    }
                },

                {
                    name            : 'Account Name',
                    displayName     : that.labels.report.columnHeaders.account_name,
                    field           : 'account_name',
                    visible         : false
                },

                {
                    name            : 'Code',
                    displayName     : that.labels.report.columnHeaders.code,
                    field           : 'transaction_code',
                    visible         : false
                },

                {
                    name            : 'Code Text',
                    displayName     : that.labels.report.columnHeaders.code_text,
                    field           : 'transaction_text',
                    visible         : false,
                    renderHtml      : true,
                    formatCallback  : function () {
                        
                        return that.reports.dataUtils.isBlank(this.transaction_processor_code) ? '' :
                            that.braintreeTransactionCodes[this.transaction_processor_code.toString()];
                    },
                    filter: {
                        type: that.uiGridConstants.filter.SELECT,
                    }
                },

                {
                    name            : 'Status',
                    displayName     : that.labels.report.columnHeaders.status,
                    field           : 'transaction_status',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.transaction_status) ? '' :
                            that.braintreeTransactionStatuses[this.transaction_status.toString()];
                    },
                    filter: {
                        type: that.uiGridConstants.filter.SELECT
                    }
                },

                {
                    name            : 'Type',
                    displayName     : that.labels.report.columnHeaders.type,
                    field           : 'transaction_type',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function () {

                        return that.reports.dataUtils.isBlank(this.transaction_type) ? '' :
                            that.braintreeTransactionTypes[this.transaction_type.toString()];
                    },
                    filter: {
                        type: that.uiGridConstants.filter.SELECT
                    }
                },

                {
                    name            : 'Contract Start',
                    displayName     : that.labels.report.columnHeaders.contract_start,
                    field           : 'reservation_pickup',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.reservation_pickup) {
                            return that.reports.dataUtils.formatDateSimple(this.reservation_pickup)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.reservation_pickup, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Contract Start Time Zone',
                    displayName     : that.labels.report.columnHeaders.contract_start_time_zone,
                    field           : 'reservation_pickup_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.reservation_pickup ? that.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Contract Finish',
                    displayName     : that.labels.report.columnHeaders.contract_finish,
                    field           : 'reservation_dropoff',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.reservation_dropoff) {
                            return that.reports.dataUtils.formatDateSimple(this.reservation_dropoff)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.reservation_dropoff, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Contract Finish Time Zone',
                    displayName     : that.labels.report.columnHeaders.contract_finish_time_zone,
                    field           : 'reservation_dropoff_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.reservation_dropoff ? that.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Transaction Date',
                    displayName     : that.labels.report.columnHeaders.transaction_date,
                    field           : 'transaction_date',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.transaction_date) {
                            return that.reports.dataUtils.formatDateSimple(this.transaction_date)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.transaction_date, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Transaction Date Time Zone',
                    displayName     : that.labels.report.columnHeaders.transaction_date_time_zone,
                    field           : 'transaction_date_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.transaction_date ? that.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Settlement Date',
                    displayName     : that.labels.report.columnHeaders.settlement_date,
                    field           : 'settlement_date',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.settlement_date) {
                            return that.reports.dataUtils.formatDateSimple(this.settlement_date)
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.settlement_date, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Settlement Date Time Zone',
                    displayName     : that.labels.report.columnHeaders.settlement_date_time_zone,
                    field           : 'settlement_date_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.settlement_date ? that.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Disbursement Date',
                    displayName     : that.labels.report.columnHeaders.disbursement_date,
                    field           : 'disbursement_date',
                    visible         : true,
                    exporterFieldCallback: function ( value: any ) {
                        return value.replace(/^(.*) ([A-Z]{3})$/, '$1');
                    },
                    formatCallback  : function() {

                        if (this.disbursement_date) {
                            return moment(this.disbursement_date).utc().format('M/D/YYYY')
                                + ' ' + that.reports.dataUtils.formatTimeSimple(this.disbursement_date, that.reports.timeZone)
                                + ' ' + that.reports.timeZoneCode;
                        }

                        return '';
                    },
                    enableFiltering : false
                },

                {
                    name            : 'Disbursement Date Time Zone',
                    displayName     : that.labels.report.columnHeaders.disbursement_date_time_zone,
                    field           : 'disbursement_date_time_zone',
                    hideColumnVisibilityMenuItem: true,
                    visible         : false,
                    exporterFieldCallback: function (value: any, unmungedValue: any, row: any ) {
                        return row.disbursement_date ? that.reports.timeZoneCode : '';
                    }
                },

                {
                    name            : 'Amount',
                    displayName     : that.labels.report.columnHeaders.amount,
                    field           : 'transaction_total',
                    visible         : true,
                    formatCallback  : function () {
                        return that.$dealerwareInternationalizationData.getCurrencyLabel(this.transaction_total);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'gteq',
                                startRange  : 7
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'transaction_total';

                        that.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'transaction_total',
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : that.reports.calculateNumericFilter
                        });
                        that.reports.showFilterModal(filterField);
                    },

                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                },

                {
                    name            : 'Transaction Fee',
                    displayName     : that.labels.report.transaction_fee,
                    field           : 'transaction_fee',
                    visible         : true,
                    formatCallback  : function () {
                        return that.$dealerwareInternationalizationData.getCurrencyLabel(this.transaction_fee);
                    },
                    useExternalFilter: true,
                    showModal       : function ( columnScope: any ) {

                        if (! columnScope.col.modalData) {
                            columnScope.col.modalData = {
                                type        : 'gteq',
                                startRange  : 7
                            };
                        }

                        columnScope.col.savedModalData = angular.copy(columnScope.col.modalData);

                        var filterField = 'transaction_fee';

                        that.reports.setFilterControlData(filterField, {
                            title                   : this.name,
                            field                   : 'transaction_fee',
                            template                : numericTemplate,
                            gridColumn              : columnScope.col,
                            calculateFilterFunction : that.reports.calculateNumericFilter
                        });
                        that.reports.showFilterModal(filterField);
                    },

                    filterHeaderTemplate: filterHeaderHtml,
                    cellClass           : 'ui-grid-cell-contents-number'
                }
            ];

            this.setReportsConfiguration();
            this.menuizeBraintreeApiResponses();
        }

        private menuizeBraintreeApiResponses () : void {

            var that = this;

            this.menuizedBraintreeApiResponses.codes = Object.keys(this.braintreeTransactionCodes)
                .sort()
                .map( ( code: string ) => {
                        return { value: code.toString(), label: (<any>that.braintreeTransactionCodes)[code] };
                    }
                );

            this.menuizedBraintreeApiResponses.statuses = Object.keys(this.braintreeTransactionStatuses)
                .sort()
                .map( ( status: string ) => {
                        return { value: status, label: (<any>that.braintreeTransactionStatuses)[status] };
                    }
                );

            this.menuizedBraintreeApiResponses.types = Object.keys(this.braintreeTransactionTypes)
                .sort()
                .map( ( type: string ) => {
                        return { value: type, label: (<any>that.braintreeTransactionTypes)[type] };
                    }
                );

            this.gridColumns.forEach( ( column: any ) => {

                if (column.field === 'transaction_text') {
                    // Setting these options at gridColumns definition time is too late, because
                    // the controller hasn't loaded yet, which is when this method runs.
                    //
                    column.filter.selectOptions = that.menuizedBraintreeApiResponses.codes.map( ( codeOrMap: any ) => {
                        // Bleah.  But the backend needs to search on the literal Braintree code text, so whatever.
                        //
                        return { value: codeOrMap.label, label: codeOrMap.label };
                    });
                }
                else if (column.field === 'transaction_status') {
                    column.filter.selectOptions = that.menuizedBraintreeApiResponses.statuses;
                }
                else if (column.field === 'transaction_type') {
                    column.filter.selectOptions = that.menuizedBraintreeApiResponses.types;
                }
            });
        }

        public loadAllDataForExport ( ) : ng.IPromise<any> {
            return this.reports.loadAllDataForExport();
        }

        public setReportsConfiguration () : void {

            var that = this;

            // This report's configuration.
            //
            this.configuration = {
                grid        : {
                    defaultSorts    : this.defaultGridSorts,
                    defaultFilters  : {},
                    columnMap       : this.apiToGridMapTransactions,
                    columns         : this.gridColumns
                },
                collection  : {
                    model           : this.DealerwareContractCollection,
                    loadMethod      : 'transactions'
                },
                pager       : {
                    pageSizes       : [ { value: 30, display: '30' }, { value: 100, display: '100' } ]
                },
                $scope              : this.$scope
            };

            // Add base controller members to this report.
            //
            this.reports = this.$controller('ReportsController', {
                thisReportConfiguration : this.configuration,
                '$scope'                : this.$scope
            });

            // CSV config uses bases ReportsController methods for dataLoading,
            // but they could be custom for this report.
            //
            var exportFileName = 'transactions_' + moment().format('YYYY_MM_DD') + '.csv';
            this.configuration.csvExport = {
                showExporterMenu    : false,
                thisPage    : {
                    fileName        : exportFileName,
                    dataLoadMethod  : this.reports.loadThisPageDataForExport
                },
                allPages    : {
                    fileName        : exportFileName,
                    dataLoadMethod  : ( ) => {
                        return this.loadAllDataForExport.call (that);
                    },
                    sort: {
                        by         : 'transaction_date',
                        direction  : 'desc'
                    }
                }
            };

            // update the export filename to add location name after the location has loaded
            this.$scope.$watch(() => {
                return this.reports.locationName;
            }, (locationName: string) => {
                if (locationName) {
                    var exportFileName = this.$filter('spaceless')(locationName.toLowerCase()) + '_transactions_' + moment().format('YYYY_MM_DD') + '.csv';

                    this.configuration.csvExport.thisPage.fileName = exportFileName;
                    this.configuration.csvExport.allPages.fileName = exportFileName;
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ReportsTransactionsDirectiveController',
        ReportsTransactionsDirectiveController
    );


    export class ReportsTransactionsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ReportsTransactionsDirectiveController';
        public controllerAs     : string    =   'vm';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/reports/transactions/transactions-directive.html';
        public scope            : Object    =   { };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareReportsTransactions',
        ( ) => new ReportsTransactionsDirective()
    );
}

